import axios from 'axios';
import { logout } from './userActions';

const FRONTEND_AUTH_ERROR_CODES = new Set([1001, 1002, 1003]);

const hasAuthErrorCodePrefix = (message) => {
	if (typeof message !== 'string') return false;
	const match = message.trim().match(/^([0-9]+)\s*-\s+/);
	if (!match) return false;
	return FRONTEND_AUTH_ERROR_CODES.has(Number(match[1]));
};

const isAuthErrorResponse = (data) => {
	if (!data || typeof data !== 'object') return false;
	if (data.session_expired === true) return true;
	if (FRONTEND_AUTH_ERROR_CODES.has(Number(data.error_code))) return true;
	if (hasAuthErrorCodePrefix(data.msg)) return true;
	return false;
};

export const getWatcherAssetsInitials = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/assets`, config);

		// const data = {
		// 	DAssetsCols: [ 'Watcher ID', 'Device IP', 'Device MAC', 'Device Vendor', 'First Seen', 'Known' ],
		// 	KAssetsCols: [ 'Watcher ID', 'Device IP', 'Device MAC', 'Device Vendor' ],
		// 	status: true,
		// 	watchercols: [ 'WatcherID', 'Watcher SN', 'Version', 'Status', 'Last Seen' ],
		// 	watchers: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ]
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
		// return err.response && err.response.data ? err.response.data : err.message;
	}
};

export const getWatcherAssetsData = (formData) => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.post(`/api/assets`, formData, config);

		// const data = {
		// 	DAssetsCols: [ 'Watcher ID', 'Device IP', 'Device MAC', 'Device Vendor', 'First Seen', 'Known' ],
		// 	DAssetsRows: [
		// 		[ 'V-Watcher200', '172.16.3.57', '00:0c:29:fa:17:7a', 'VMware Inc', 'Mon, 07 Mar 2022 17:15:49 GMT', 'False' ],
		// 		[
		// 			'V-Watcher200',
		// 			'172.16.3.166',
		// 			'00:e0:4c:68:03:2f',
		// 			'Realtek Semiconductor Corp',
		// 			'Sun, 20 Mar 2022 15:23:11 GMT',
		// 			'False'
		// 		],
		// 		[
		// 			'V-Watcher200',
		// 			'172.16.3.1',
		// 			'00:e0:4c:d9:ba:b4',
		// 			'Realtek Semiconductor Corp',
		// 			'Thu, 28 Apr 2022 23:46:15 GMT',
		// 			'False'
		// 		]
		// 	],
		// 	KAssetsCols: [ 'Watcher ID', 'Device IP', 'Device MAC', 'Device Vendor', 'Hostname' ],
		// 	KAssetsRows: [],
		// 	WatcherName: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ],
		// 	status: true,
		// 	watchers: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ]
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
		// return err.response && err.response.data ? err.response.data : err.message;
	}
};

export const addKnownAssetsData = (formData) => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.post(`/api/upload-known-assets`, formData, config);
		// const data = {
		// 	msg: 'File has been uploaded',
		// 	status: true
		// };

		// return data;
		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		// return err.response && err.response.data ? err.response.data : err.message;
		return {};
	}
};

export const getWatcherDataInitials = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/data`, config);
		// const data = {
		// 	CTRCols: [ 'Country', 'Count' ],
		// 	CTRRows: [],
		// 	DNSCols: [ 'DNS', 'Count' ],
		// 	DNSRows: [],
		// 	IPsCols: [ 'IP Address', 'Count' ],
		// 	IPsRows: [],
		// 	PortsCols: [ 'Ports', 'Count' ],
		// 	PortsRows: [],
		// 	UrlCols: [ 'URLs', 'Count' ],
		// 	UrlRows: [],
		// 	WatcherName: [],
		// 	status: true,
		// 	watchers: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ]
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
		// return err.response && err.response.data ? err.response.data : err.message;
	}
};

export const getWatcherData = (formData) => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.post(`/api/data`, formData, config);

		// const data = {
		// 	CTRCols: [ 'Country', 'Count' ],
		// 	CTRRows: [ [ 'lorem', 'ipsum' ], [ 'lorem', 'ipsum' ] ],
		// 	DNSCols: [ 'DNS', 'Count' ],
		// 	DNSRows: [],
		// 	IPsCols: [ 'IP Address', 'Count' ],
		// 	IPsRows: [],
		// 	PortsCols: [ 'Ports', 'Count' ],
		// 	PortsRows: [],
		// 	UrlCols: [ 'URLs', 'Count' ],
		// 	UrlRows: [
		// 		[ 'lorem', 'ipsum' ],
		// 		[ 'lorem', 'ipsum' ],
		// 		[ 'lorem', 'ipsum' ],
		// 		[ 'lorem', 'ipsum' ],
		// 		[ 'lorem', 'ipsum' ],
		// 		[ 'lorem', 'ipsum' ],
		// 		[ 'lorem', 'ipsum' ],
		// 		[ 'lorem', 'ipsum' ],
		// 		[ 'lorem', 'ipsum' ],
		// 		[ 'lorem', 'ipsum' ]
		// 	],
		// 	WatcherName: [],
		// 	status: true,
		// 	watchers: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ]
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
		// return err.response && err.response.data ? err.response.data : err.message;
	}
};

export const getWatcherStatusData = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/status`, config);

		// const data = {
		// 	status: true,
		// 	watchercols: [ 'WatcherID', 'Watcher SN', 'Version', 'Status', 'Last Seen' ],
		// 	watcherrows: [
		// 		[ 'lorem', 'ipsum', 'ipsum', 'ipsum', 'ipsum' ],
		// 		[ 'lorem', 'ipsum', 'ipsum', 'ipsum', 'ipsum' ],
		// 		[ 'lorem', 'ipsum', 'ipsum', 'ipsum', 'ipsum' ],
		// 		[ 'lorem', 'ipsum', 'ipsum', 'ipsum', 'ipsum' ],
		// 		[ 'lorem', 'ipsum', 'ipsum', 'ipsum', 'ipsum' ]
		// 	]
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
		// return err.response && err.response.data ? err.response.data : err.message;
	}
};

export const getAssetBaselineInitials = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/asset-baseline`, config);

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return err.response && err.response.data ? err.response.data : {};
	}
};

export const getAssetBaselineData = (formData) => async (dispatch) => {
	try {
		// Remove the incorrect headers config when sending FormData
		// FormData automatically sets the correct Content-Type with boundary
		const { data } = await axios.post(`/api/asset-baseline`, formData);

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		console.error('Asset baseline data error:', err);
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return err.response && err.response.data ? err.response.data : {};
	}
};

// ── Observed external attack surface (traffic-fed MorningWatch view) ──────────
// GET returns the watcher list + an empty surface (for the initial dropdown);
// POST returns the aggregated surface for the selected watcher/window.
export const getObservedSurfaceInitials = () => async (dispatch) => {
	try {
		const config = { headers: { 'Content-Type': 'application/json' } };
		const { data } = await axios.get(`/api/observed-surface`, config);
		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		}
		return {};
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return err.response && err.response.data ? err.response.data : {};
	}
};

export const getObservedSurface = (formData) => async (dispatch) => {
	try {
		const { data } = await axios.post(`/api/observed-surface`, formData);
		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		}
		return {};
	} catch (err) {
		console.error('Observed surface data error:', err);
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return err.response && err.response.data ? err.response.data : {};
	}
};


// SOC Analytics allowlist — per-client suppression of known-good findings.
export const getSocAllowlist = (company = '') => async (dispatch) => {
	try {
		const { data } = await axios.post(`/api/soc-allowlist`, { company });
		if (data && data.status) return data;
		if (data && data.type === 'auth') { dispatch(logout()); return {}; }
		return { status: false, msg: (data && data.msg) || 'Failed to load allowlist' };
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) { dispatch(logout()); return {}; }
		return { status: false, msg: err?.response?.data?.msg || err?.message || 'Failed to load allowlist' };
	}
};

export const addSocAllowlist = (payload) => async (dispatch) => {
	try {
		const { data } = await axios.post(`/api/soc-allowlist/add`, payload);
		if (data && data.type === 'auth') { dispatch(logout()); return {}; }
		return data || { status: false, msg: 'No response' };
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) { dispatch(logout()); return {}; }
		return { status: false, msg: err?.response?.data?.msg || err?.message || 'Failed to add entry' };
	}
};

export const deleteSocAllowlist = (id) => async (dispatch) => {
	try {
		const { data } = await axios.post(`/api/soc-allowlist/delete`, { id });
		if (data && data.type === 'auth') { dispatch(logout()); return {}; }
		return data || { status: false, msg: 'No response' };
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) { dispatch(logout()); return {}; }
		return { status: false, msg: err?.response?.data?.msg || err?.message || 'Failed to remove entry' };
	}
};


// SOC Analytics — behavioural detections over ingested telemetry (read-only queue).
export const getSocAnalytics = (watcherId = 'All Watchers') => async (dispatch) => {
	try {
		const { data } = await axios.post(`/api/soc-analytics`, { watcherId });
		if (data && data.status) return data;
		if (data && data.type === 'auth') { dispatch(logout()); return {}; }
		return { status: false, msg: (data && data.msg) || 'Failed to load analytics' };
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) { dispatch(logout()); return {}; }
		return { status: false, msg: err?.response?.data?.msg || err?.message || 'Failed to load analytics' };
	}
};


// MorningWatch — per-client CVE findings on the client's own systems.
export const getVulnerabilities = (watcherId = 'All Watchers') => async (dispatch) => {
	try {
		const { data } = await axios.post(`/api/vulnerabilities`, { watcherId });
		if (data && data.status) return data;
		if (data && data.type === 'auth') { dispatch(logout()); return {}; }
		return { status: false, msg: (data && data.msg) || 'Failed to load findings' };
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) { dispatch(logout()); return {}; }
		return { status: false, msg: err?.response?.data?.msg || err?.message || 'Failed to load findings' };
	}
};
